import React, {useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import {useParams } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap-icons/font/bootstrap-icons.css';
import bild from  '../softgewerk.png';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import {
  Link
} from "react-router-dom";
import '../App.css';
import { Table } from 'react-bootstrap';

const Notdienst = () => {

 
  const [LoadingModal, setLoadingModal] = useState(false);
  const [grund, setgrund] = useState('');
  const [name, setname] = useState('');
  const [telefon, settelefon] = useState('');
  const [absenden, setabsenden] = useState(false);
  const [validierung, setvalidierung] = useState(false);
  const [Show, setShow] = useState(false);

  const [anzeigename, setanzeigename] = useState('');
  const [anzeigestrasse, setanzeigestrasse] = useState('');
  const [anzeigeadresse, setanzeigeadresse] = useState('');
  const [anzeigetelnr, setanzeigetelnr] = useState('');
  const [geraetedaten, setgeraetedaten] = useState([]);




    var { id } = useParams();


    useEffect(() => {
       
   const load = async () => {

    
    try {
      const res = await axios.get('https://wartung.hoermann-fn.de/anzeige.php', {
      params: { id: id}, 
      
      
      });
      
      
      setanzeigename(res.data.Name);
      setanzeigestrasse(res.data.Strasse);
      setanzeigeadresse(res.data.Adresse);
      setanzeigetelnr(res.data.TelNr);

     
     
   
     
    } catch (err) {
      if (err.response.status === 500) {
        alert('There was a problem with the server');
      } else {
        alert(err.response.data.msg);
      }
      
    } 



   }


   const loadGeraetedaten = async () => {

    
    try {
      const res = await axios.get('https://wartung.hoermann-fn.de/anzeigeGeraetedaten.php', {
      params: { id: id}, 
      
      
      });
      
      
      setgeraetedaten(res.data.daten);


     
     
   
     
    } catch (err) {
      if (err.response.status === 500) {
        alert('There was a problem with the server');
      } else {
        alert(err.response.data.msg);
      }
      
    } 



   }
 
   load();
   loadGeraetedaten();
        
       

    }, []);

   
      const infos = async () => {
        if(name === '' || telefon === ''){
          setvalidierung(true);
          setShow(true);
        } else {
          setShow(false);
          setvalidierung(false);
          setLoadingModal(true);
          
       

          try {
                  const res = await axios.get('https://wartung.hoermann-fn.de/MailSenden.php', {
                  params: { id: id, grund: grund, name: name , telefon: telefon}, 
                  
                  
                  });
                  
                  
            
                 
                 
               
                 setLoadingModal(false);
                 setabsenden(true);
                 
                } catch (err) {
                  if (err.response.status === 500) {
                    alert('There was a problem with the server');
                  } else {
                    alert(err.response.data.msg);
                  }
                  
                } 
    

        }
       
              
            }
  
  

    const external = () => {
      window.open('https://www.hoermann-fn.de', '_blank');
    }

  

      

          
      
 

  return (
    <Container className='hintergrundd'>
        <br></br>
      <Row className="text-center justify-content-center">
  <Col xs={7} md={2}  >
  <h3>Serviceportal</h3><br></br>
  <img className='img-fluid' src={bild}/>
  </Col>
</Row>
<br/>

<Row>
    <Col xs={12} className="text-center">

    {LoadingModal === true ? (
        <Row>
        <Col  xs={12} className="text-center">
        <Spinner animation="border" variant="primary" />
        </Col>
       
       </Row>
       ) : (

        absenden === true ? (
          <div class="d-grid col-md-12 col-12 mx-auto">
             <br></br>
             <br></br>
  <h3>vielen Dank für Ihre Notdiensterfassung, unser Servicetechniker wird sich schnellstmöglich mit Ihnen in Verbindung setzen.</h3><br></br>
          </div>
          
        ) : (

            <div class="d-grid col-md-12 col-12 mx-auto">
            <h3>Sehr geehrter Kunde/Kundin,</h3>
            <br></br>
            <br></br>
            <h3>vielen Dank für Ihre Notdiensterfassung, unser Servicetechniker wird sich schnellstmöglich mit Ihnen in Verbindung setzen. <br></br><br></br>
{geraetedaten.length === 0 ? (
    null
) : (
<div>
<h3>Folgende Gerätedaten sind für Ihre Wartung bei uns hinterlegt:</h3><br></br>

<Row>
<Col xs={12}>
  <Table striped responsive bordered hover>
  <thead>
  <tr>
<th>Hersteller</th>
<th>Leistung</th>
<th>Baujahr</th>
<th>Seriennummer</th>
</tr>
  </thead>

  <tbody>
  {
  
      
     
  geraetedaten.map((v, index) => (
  <tr>
 {<td >{v.Hersteller}</td>}
 {<td >{v.Leistung}</td>}
 {<td >{v.Baujahr}</td>}
 {<td >{v.Seriennummer}</td>}



    </tr>
  )  
)}

  </tbody>

  </Table>
</Col>
</Row>
</div>
)


}
        
            
            
            Folgende Informationen liegen uns bereits vor und sind aus datenschutzrechtlichen Gründen zensiert:<br></br><br></br>

            Name: {anzeigename} <br></br>
            Straße: {anzeigestrasse} <br></br>
            Adresse: {anzeigeadresse} <br></br>
            Telefonnummer: {anzeigetelnr} <br></br> <br></br>

            

            
             Bitte erfassen Sie optional eine kurze Notiz, worum
                es sich handelt und geben Sie Ihre Kontaktdaten an, sofern diese von den oben dargestellten Informationen abweichen sollten. Wir rufen Sie dann schnellst möglich zurück.</h3><br></br>
            <Col xs={12}>
            <Form.Control onChange={(e) => setname(e.target.value)} placeholder='Name...'   /> <br></br>
            <Form.Control onChange={(e) => settelefon(e.target.value)} placeholder='Telefonnummer oder Mobilnummer...'  /> <br></br>
          <Form.Control onChange={(e) => setgrund(e.target.value)} placeholder='Notizen zur Störung erfassen...' as="textarea" rows={6} /> <br></br>

          {Show === true ? (

<Alert variant="danger" onClose={() => setShow(false)} dismissible>
<p>
Bitte tragen Sie Ihren Namen und Ihre Telefonnummer oder Mobilnummer ein, bevor Sie auf 'Absenden' klicken.
</p>
</Alert>

) : (null)}

          <button onClick={infos} type="button"  class="btnn">Absenden</button><br></br><br></br><br></br>
          <h3>Bitte beachten Sie:</h3> <br></br>
          <ul style={{listStyleType: 'none'}}>
            <li>Unser 365 Tage Heizungs-Notdienst steht exklusiv unseren Kunden mit aktivem Wartungsvertrag zur Verfügung</li>
            <li>Notdienstzeiten außerhalb der Öffnungszeiten
                <ul style={{listStyleType: 'none'}}>
                    <li>Mo-Do 16:30 Uhr - 20:00 Uhr </li>
                    <li>Fr 14:00 – 20:00 Uhr </li>
                    <li>Sa/So 08:00 – 20:00 Uhr </li>
                </ul>
            </li>
            <li>Bitte senden Sie die Anfrage nur 1x ab. </li>
          </ul>
          </Col>
            
            </div>

        )
        
    

       )
 
  
     
   
   
   
   
  
}
</Col>
   
 
   
 
 
  
  

   

  
 
    <br></br>
    <br></br>
    <Col xs={12} className="text-center">
  <br></br>  <br></br>  <br></br>  <br></br>  <br></br>  <br></br>  <br></br>  <br></br>  
<p>Interessieren Sie sich für eine neue effiziente Heizungsanlage dann lassen Sie sich ein kostenloses und unverbindliches Angebot von uns erstellen. <br></br></p>
<br></br>

<a style={{ color: 'blue'}}  onClick={external}>www.hoermann-fn.de</a>

    </Col>
</Row>

    </Container>
  )
}

export default Notdienst